import React from "react";

const CommunityCard = (props) => {
	return (
		<>
			<div className="w-full max-w-[450px] flex justify-start items-center  flex-col">
				<div className="w-full flex justify-center items-center  flex-col rounded-2xl h-[506px] w-full overflow-hidden relative">
					<img
						src={props.data.img}
						alt="img"
						className="block object-cover w-full h-full"
					/>
				</div>
				<div className="flex justify-start items-start flex-col ">
					<h1 className="text-[0.9375rem] font-[500] mt-3">
						{props.data.heading}
					</h1>
					<p className="leading-[1.375rem ] text-[0.9375]">
						{props.data.paragraph}
					</p>
				</div>
			</div>
		</>
	);
};

export default CommunityCard;
